const nobgPages = [
	"public-notice",
	"company-profile",
	"download",
	"lp-series",
	"privacy-policy",
	"contact",
	"w-deps",
	"wo-deps"
];
var videos = [
	
];
var Video = {
	name: "",
	filePC: "",
	fileSP: ""
}
var page = {
	isFirst : true,
	isPage 	: "",
	current	: "",
	next 	: "",
	id 		: "",
	folder 	: "",
	clickFlag: true,
	first: true,
	hasGL: false,
	beforeW: 0, //GLのリサイズによるチラツキ防止のため
	init: function(){
		let url = "/movie.php";
		common.getJson(url).done(function(json){
			for(var i = 0; i < json.movie_pc.length; i++){
				var v = object(Video);
				v.name = json.movie_pc[i].name;
				v.filePC = json.movie_pc[i].file;
				v.fileSP = json.movie_sp[i].file;
				videos.push(v);
			}
			var videoNum = Math.floor(Math.random()*videos.length);
			let date = new Date();
			let num = date.getTime();
			if(isSP){
				var HTML = '<video id="videoTexture" muted="" autoplay="" playsinline="" loop="" crossorigin="anonymous" style="display:none"><source src="' + videos[videoNum].fileSP + "?" + num + '" type="video/mp4"></video>';
			}else{
				var HTML = '<video id="videoTexture" muted="" autoplay="" playsinline="" loop="" crossorigin="anonymous" style="display:none"><source src="' + videos[videoNum].filePC + "?" + num + '" type="video/mp4"></video>';
			}
			$("#wrap_video").html(HTML);
			var n = ( '000' + (videoNum+1) ).slice( -3 )
			var text = "#" + n + " " + videos[videoNum].name;
			$("#brain_id h5").attr("data-text", text);
			randomText.init();
			
			console.log("movie:", json);
			console.log("PAGE:", page.isPage);
			
			
			setTimeout(function(){
				var $video = $("#videoTexture")[0];
				$video.onloadeddata = function(){
					//console.log("first",page.isFirst, page.isPage)
					console.log("video loaded");
					if (window.matchMedia('all and (min-width : 864px)').matches) {
						if(page.isPage != home){
							var _h = $("#bg").outerHeight();
						}else{
							var _h = window.innerHeight;
						}
					} else if(window.matchMedia('all and (min-width : 0px)').matches) {
						if(page.isPage != home){
							var _h = Math.floor(window.innerWidth*.8);
						}else{
							var _h = window.innerHeight - 50;
						}
					}
					
					if(page.isFirst){
						if(page.isPage === "home"){
							var n = -1;
						}else{
							var n = parseInt($("#content").attr("data-num"));
						}
						var videoID = "videoTexture";
						//console.log("GL init時に投げている値", "width:", window.innerWidth, "height:", window.innerHeight);
						/* 2019.03.07
						window.webgl.init({
							canvasId: "main",
							videoId: "videoTexture",
							developMode: false,
							debugCamera: false,
							finishAnimationType: n,
							width: window.innerWidth,
							height: _h
						});
						*/
						//2019.03.08
						var sp = false;
						if(isSP){
							sp = true;
						}else{
							sp = false;
						}
						//console.log(_h);
						window.webgl.init({
							canvasId: "main",
							videoId: "videoTexture",
							developMode: false,
							debugCamera: false,
							finishAnimationType: n,
							width: window.innerWidth,
							height: _h,
							isSp: sp
						});
					}
					page.hasGL = true;
					page.checkURL();
					page.nav();
					if(page.isPage != "home"){
						$(".index #block_main").addClass("active");
						$("#bg").removeClass("disable");
					}
				}
			},100);
			
			common.resize();
			window.addEventListener('popstate', function (e) {
				/*
				if(page.canClick){
					page.canClick = false;
					page.checkURL();
				}*/
				page.checkURL();
			});
		});
	},
	nav: function(){
		var path = "";
		$("#glbnav_pc a").off("click").on("click", function(e){
			let $this = $(this);
			if(!$this.hasClass("link_external")){
				e.preventDefault();
				$("#glbnav_pc a").removeClass("active");
				$this.addClass("active");
				path = $this.attr("href");
				changeURL(path);
			}
		});
		$("#fnav a").off("click").on("click", function(e){
			if(!$(this).hasClass("link_external")){
				e.preventDefault();
				$("#glbnav_pc a").removeClass("active");
				$(this).addClass("active");
				path = $(this).attr("href");
				changeURL(path);
			}
		});
		$("#subnav a").off("click").on("click", function(e){
			if(!$(this).hasClass("link_external")){
				e.preventDefault();
				if(!$(this).hasClass("active")){
					path = $(this).attr("href");
					changeURL(path);
				}
			}
		});
		$("#glbnav ul li a").not(".internal").off().on("click", function(e){
			e.preventDefault();
			path = $(this).attr("href");
			changeURL(path);
		});

		$("a.link_internal").off().on("click", function(e){
			e.preventDefault();
			path = $(this).attr("href");
			changeURL(path);
		});
		function changeURL(path){
			if(page.canClick){
				page.canClick = false;
				page.changeURL(path);
			}
		}
	},
	checkNav: function(){
		var folders = location.pathname.split("/"),
			len = folders.length,
			current = folders[len-2];
		//PC
		$("#glbnav_pc li a").removeClass("active");
		$("#nav_sub_technology li a").removeClass("active");
		$("#global_header").removeClass("sub");
		$("#fnav li a").removeClass("active");
		//SP
		$("#glbnav li a").removeClass("active");
		$("#glbnav .accordion li a").removeClass("active");
		
		if(lang === "en"){
			if(len === 5 && folders[len-3] === "technology"){
				classTech();
			}else{
				classElse();
			}
		}else{
			if(len === 4 && folders[len-3] === "technology" || len === 3 && folders[len-2] === "technology"){
				classTech();
			}else{
				classElse();
			}
		}
		function classTech(){
			$("#nav_sub_technology li a[data-nav='" + current + "']").addClass("active");
			//$("#glbnav .accordion li a[data-nav='technology']").addClass("active");
			$("#glbnav_pc li a[data-nav='technology']").addClass("active");
			$(".accordion li a[data-nav='" + current + "']").addClass("active");
			if(!$("header#global_header").hasClass("open_subnav")){
				$("header#global_header").addClass("open_subnav");
			}
		}
		function classElse(){
			if(current === "technology"){
				$("#nav_sub_technology li a").removeClass("active");
				$("#nav_sub_technology li").eq(0).find("a").addClass("active");
			}
			$("#fnav li a[data-nav= '" + current + "']").addClass("active");
			$("#glbnav_pc li a[data-nav= '" + current + "']").addClass("active");
			$("#glbnav li a[data-nav= '" + current + "']").addClass("active");
			if($("header#global_header").hasClass("open_subnav")){
				$("header#global_header").removeClass("open_subnav");
			}
		}
		
		//check need background
		let $wrap = $("#wrap");
		
		//console.log(nobgPages.includes(page.isPage), page.isPage);
		if(nobgPages.includes(page.isPage)){
			if($wrap.hasClass("show_bg")){
				$wrap.removeClass("show_bg");
			}
			$("#in_page_scroll").addClass("disable");
		}else{
			var isNewsFolder = 1;
			var isNewsLen = 4;
			if(lang === "en"){
				isNewsFolder = 2;
				isNewsLen = 5;
			}
			if(folders[isNewsFolder] === "news" && len >= isNewsLen){
				common.checkNews();
				if($wrap.hasClass("show_bg")){
					$wrap.removeClass("show_bg");
					$("#in_page_scroll").addClass("disable");
				}
			}else if(folders[isNewsFolder] === "news" && len < isNewsLen){
				//パンくずの最後を消す
				$("#block_bread li.cat").remove();
			}else{
				if(!$wrap.hasClass("show_bg")){
					$wrap.addClass("show_bg");
				}
				if(page.isPage != "home"){
					if($("#in_page_scroll").hasClass("disable")){
						$("#in_page_scroll").removeClass("disable");
					}
				}
			}
		}
	},
	changeHTMLClass: function(){
		if(page.isPage === "home"){
			$html.classList.remove("page");
			$html.classList.add("index");
			$html.classList.add("page_index");
			$html.classList.add("active0");
			$("#in_page_scroll").addClass("disable");
		}else{
			if($html.classList.contains("index")){
				$html.classList.remove("page_index");
				$html.classList.remove("index");
				$html.classList.add("page");
			}

			for(var i = 0; i < 6; i++){
				let cls = "active" + i;
				if($html.classList.contains(cls)){
					$html.classList.remove(cls);
				}
			}
		}
	},
	changeURL: function(folder){
		window.history.pushState(null, null, folder);
		page.checkURL();
	},
	changePage: function(){
		var loadURL = page.current,
			$body 	= $("body");
		if(page.isPage != "home"){
			$("#wrap").off();
			$(document).off();
		}
		let cls = "c" + Math.floor( Math.random()*2 );
		//console.log(cls);
		$("#logo_loading").removeClass().addClass(cls);
		page.showLoading().done(function(){
			$.get(loadURL,{},function(data){
				window.scrollTo(0,0);

				if($body.hasClass("nav")){
					$body.removeClass("nav");
				}
				page.changeHTMLClass();
				page.changeContent(data).done(function(){
					//console.log("end changecontent")
				});
			});
		});
	},
	changeContent: function(data){
		var defer = $.Deferred();
		//console.log(data);
		var out_html 	= $(data),
			ttl 		= out_html.filter("title")[0].innerHTML,
			$content 	= $("#content_inner"),
			content 	= $("#content", out_html)[0],
			bread 		= out_html.filter("#block_bread")[0].innerHTML;

		//console.log(bread)
		$("#block_bread").html(bread);
		document.title = ttl;
		//console.log(content);
		$content.html(content);

		var imgArry = [];
		$("#content img").each(function(){
			imgArry.push($(this).attr("src"));
		});
		if(imgArry.length > 0){
			preload.startLoad(imgArry.length,imgArry).done(function(){
				afterLoadImg();
			});
		}else{
			afterLoadImg();
		}
		function afterLoadImg(){
			if(page.isPage === "home"){
				//ロード時トップでなかったら
				if(!page.isFirst){
					$(".index #block_main").addClass("active");
					$("#bg").removeClass("disable");
				}
			}
			setTimeout(function(){
				page.afterLoadPage();
				//GLを変化させる
				if(page.isPage === "home"){
					randomText.run();
					window.webgl.initSequence(0);
				}else{
					var n = parseInt($("#content").attr("data-num"));
					window.webgl.changeParticleScene(1.2, n);
				}
				//console.log("isFirst:", page.isFirst)
				if(!page.isFirst){
					page.resizeGL();
				}
				$(".a").removeClass("animate animated");
				setTimeout(function(){
					page.closeLoading().done(function(){
						defer.resolve();
					});
				}, 200);
			}, 500);
		}
		return defer.promise();
	},
	showLoading: function(){
		var defer = $.Deferred();
		let $body = $("body");

		$html.classList.add("change");
		setTimeout(function(){
			$html.classList.add("show_loading");
			setTimeout(function(){
				window.webgl.boxScale_zero(0);
				$html.classList.add("disable_scroll");
				$("#loading").addClass("shift");
				setTimeout(function(){
					defer.resolve();
				}, 300);
			}, 300);
		},50);
		return defer.promise();
	},
	closeLoading: function(){
		let $body = $("body");
		let defer = $.Deferred();
		page.checkGL();
		page.resizeGL();
		$html.classList.add("close_loading");
		$html.classList.remove("show_loading");
		$html.classList.remove("disable_scroll");
		//console.log("CLOSE LOADING page:", page.isPage)
		setTimeout(function(){
			$html.classList.remove("change");
			setTimeout(function(){
				$("#loading").removeClass("shift");
				$html.classList.remove("loading");
				$html.classList.remove("close_loading");
			}, 100);
			defer.resolve();
		}, 300);
		return defer.promise();
	},
	checkURL : function(){
		let url 	= location.href;
		let prop 	= location.pathname;
		let $body 	= $("body"),
			folders = prop.split("/"),
			arg 	= new Object,
			pair 	= location.search.substring(1).split('&'),
			isModal	= false,
			folderLength 	= folders.length-2,
			folderName 		= folders[folderLength];
		page.folderName = folderName;
		//console.log(folders, folderLength, folderName);
		page.current = prop;
		if(folders[0] === "" && folders[1] === "" || folderName === "en"){
			page.isPage = "home";
		}else{
			page.isPage = folderName;
			if(page.isPage === ""){
				page.isPage = "404";
			}
		}
		if(page.isFirst){
			page.afterLoadPage();
			page.checkGL();
		}else{
			if(page.isPage === "home"){
				page.changePage();
			}else{
				page.changePage();
			}
		}
	},
	afterLoadPage: function(){
		//console.log("afterload ", page.isPage)
		common.nav();
		page.nav();
		page.checkNav();
		if(page.isPage === "home"){
			$html.classList.add("index");
			$html.classList.add("page_index");
			if(page.isFirst){
				page.changeHTMLClass();
			}
			home.init();
		}else if(page.isPage === "contact"){
			form.contact();
		}else if(page.isPage === "company"){
			$(".map").each(function(i){
				gMap(i);
			});
		}else if(page.isPage === "company-profile" || page.isPage === "lp-series" || page.isPage === "w-deps" || page.isPage === "wo-deps"){
			form.checkRadio();
		}else if(page.isPage === "products"){
			setTimeout(function(){
				common.checkBlockID();
			},1000);
		}else if(page.isPage === "404"){
			$("#in_page_scroll").addClass("disable");
		}
		if(page.isPage != "home"){
			$(document).off();
		}
		$(document).off("scroll").on("scroll", function(){
			common.scrl();
		});
		common.resize();
		common.scrl();
		page.canClick 	= true;
		if(page.isFirst){
			page.isFirst = false;
		}
		var currentURL = location.pathname;
		//console.log(currentURL,lang);
		var folders = location.pathname.split("/"),
			len = folders.length;
		
		if(lang === "en"){
			var current = folders[2];
		}else{
			var current = folders[1];
		}
		if(lang === "en"){
			//$("#select_lang option.select_en").attr("value", currentURL);
			var url = currentURL.replace("/en", "");
			$("a.lang").attr("href", url);
			//$("#select_lang option.select_en").attr("value", url);
			if(current === "news"){
				//$("#select_lang option.select_ja").attr("value", "/news/");
				$("a.lang").attr("href", "/news/");
			}
		}else{
			//$("#select_lang option.select_ja").attr("value", currentURL);
			var url = "/en" + currentURL;
			$("a.lang").attr("href", url);
			//$("#select_lang option.select_en").attr("value", url);
			if(current === "news"){
				$("a.lang").attr("href", "/en/news/");
				//$("#select_lang option.select_en").attr("value", "/en/news/");
			}else if(current === "company"){
				if(folders[2] === "public-notice"){
					$("a.lang").attr("href", "/en/");
					//$("#select_lang option.select_en").attr("value", "/en/");
				}
			}
		}
		//console.log("after change page", page.isPage);
		
		//$(".list_lang li a").attr("href", url);
		setTimeout(function(){
			if( $("body").hasClass("disable") ){
				if( $("#content").hasClass("index") || page.isPage === "home" ){
					page.startIndex();
				}else{
					$("body").removeClass("disable");
				}
			}
		},600);

		var o = 100;
		$(document).on("keyup", function(e){
			var key = e.keyCode;
			if(key === 39){
				o += 10;
				if(o > 100){
					o = 100;
				}
			}else if(key === 37){
				o -= 10;
				if(o < 0){
					o = 0;
				}
			}
			$("body").removeClass(function(index, className) {
				return (className.match(/\bo\S+/g) || []).join(' ');
			});
			var oo = Math.floor(o/10);
			$("body").addClass("o" + oo);
		});
		//NEWSのプレビュー用
		let	arg 	= new Object,
			pair 	= location.search.substring(1).split('&');
		
		for(var i = 0; pair[i]; i++) {
			var kv = pair[i].split('=');
			if(kv[0] === "preview"){
				if(kv[1] === "true"){
					$html.classList.remove("index");
					$html.classList.remove("page_index");
					$html.classList.add("page");
				}
			}
		}
		setTimeout(function(){
			if( $("body").hasClass("disable") ){
				console.log("body still has disable class");
				$("body").removeClass("disable");
			}
		}, 3000);
	},
	startIndex: function(){
		let $body = $("body");
		let hasCookie = $.cookie("lpixel");
		if(hasCookie === "visited"){
			let $body = $("body");
			$html.classList.add("change");
			
			setTimeout(function(){
				$html.classList.add("show_loading");
				setTimeout(function(){
					$html.classList.add("disable_scroll");
					$("#loading").addClass("shift");
					setTimeout(function(){
						$("body").removeClass("disable");
						page.closeLoading();
						setTimeout(function(){
							$(".index #block_main").addClass("active");
							$html.classList.remove("loading");
							setTimeout(function(){
								$("#bg").removeClass("disable");
								randomText.run();
							}, 1000);
						},600);
					}, 300);
				}, 300);
			},50);
		}else{
			$.cookie("lpixel", "visited", { expires: 1 });
			$html.classList.add("loading");
			setTimeout(function(){
				$html.classList.add("show_loading");
				setTimeout(function(){
					$html.classList.add("disable_scroll");
					$("#loading").addClass("shift");
					setTimeout(function(){
						$("body").removeClass("disable");
						page.closeLoading();
						setTimeout(function(){
							$(".index #block_main").addClass("active");
							$html.classList.remove("loading");
							setTimeout(function(){
								$("#bg").removeClass("disable");
								randomText.run();
							}, 1000);
						},600);
					}, 2000);
				},1000);
			},50);
		}
	},
	resizeGL: function(){
		let winW = window.innerWidth;
		if(page.hasGL){
			if(page.isPage != "home"){
				if(isSmallScreen){
					var _h = Math.floor(window.innerWidth*.8);
					window.webgl.resize(window.innerWidth, _h);
				}else{
					window.webgl.resize(window.innerWidth, 600);
				}
			}else{
				//console.log("home resize", "width:", window.innerWidth, "height:", window.innerHeight);
				if(isSmallScreen){
					if(winW != page.beforeW){
						window.webgl.resize(window.innerWidth, window.innerHeight-50);
					}
				}else{
					window.webgl.resize(window.innerWidth, window.innerHeight);
				}
			}
		}
		page.beforeW = winW;
	},
	checkGL: function(){
		//console.log(page.isPage, "checkGL")
		if(page.isPage === "home"){
			$("#bg").removeClass("hide");
		}else if(page.isPage === "contact"){
			$("#bg").addClass("hide");
		}else if(page.isPage === "company"){
			$("#bg").removeClass("hide");
		}else if(page.isPage === "company-profile" || page.isPage === "lp-series" || page.isPage === "w-deps" || page.isPage === "wo-deps" || page.isPage === "download"){
			$("#bg").addClass("hide");
		}else if(page.isPage === "products"){
			$("#bg").removeClass("hide");
		}else if(page.isPage === "404"){
			$("#bg").addClass("hide");
		}else{
			$("#bg").removeClass("hide");
		}
	}
}